export const GetFoodProgramSelector = ({ foodprogram: { GetFoodProgram } }) =>
  GetFoodProgram;
export const FoodProgramSelector = ({ foodprogram: { FoodProgram } }) =>
  FoodProgram;
